import { getQrSvg } from '@/lib/qr';

type QrCodeCardProps = {
  title: string;
  url: string;
  caption: string;
};

export async function QrCodeCard({ title, url, caption }: QrCodeCardProps) {
  const svg = await getQrSvg(url);

  return (
    <article className="panel qr-card">
      <div className="qr-card__header">
        <p className="eyebrow">QR</p>
        <h3>{title}</h3>
      </div>
      <div
        className="qr-card__svg"
        aria-hidden="true"
        dangerouslySetInnerHTML={{ __html: svg }}
      />
      <p className="copy">{caption}</p>
      <code className="inline-code">{url}</code>
    </article>
  );
}
